<template>
    <body class="print">
        <main class="print-report diagnosis">
            <div class="print__inner">
                <section class="print__section" v-if="summaryData">
                    <div class="print__header">
                        <h2 class="print__title">진단평가 분석리포트</h2>
                        <div class="print__info">
                            <div class="date" style="display: flex; flex-direction: row; align-items: center">
                                <img src="@/assets/images/icon/ico_report_calender.png " style="width: 2vw" />
                                <div style="margin-left: 6px">{{ summaryData?.completeDate }}</div>
                            </div>
                            <div class="code">
                                <span>응시 코드 : {{ summaryData?.participantCode }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="print__body">
                        <div class="print--top">
                            <p class="txt">{{ comSchoolAndGrade }}</p>

                            <!-- 유저이름_닉네임 -->
                            <h3 class="title">
                                {{ comUserName }}님의
                                <span class="level">KReaD 지수는 {{ summaryData?.kreadScore }} 입니다.</span>
                            </h3>
                        </div>
                        <div class="print__content" style="margin-top: 70px">
                            <h4 class="content__title">진단평가 결과</h4>
                            <div class="content__body">
                                <ul class="result__list">
                                    <li class="result__item reading">
                                        <span class="result__title"> 독해력 <span class="required">*</span> </span>
                                        <span class="result__txt">
                                            <span class="score">{{ summaryData?.accuracyRate }}</span
                                            ><span class="standard">100</span>%
                                        </span>
                                    </li>
                                    <li class="result__item solve">
                                        <span class="result__title">맞힌 문항수</span>
                                        <span class="result__txt">
                                            <span class="score">{{ summaryData?.correctCount }}</span
                                            ><span class="standard">36</span>문항
                                        </span>
                                    </li>
                                    <li class="result__item time">
                                        <span class="result__title">소요 시간</span>
                                        <span class="result__txt">
                                            <span class="score">
                                                <template v-if="summaryData?.elapsedHour !== 0"> {{ summaryData?.elapsedHour }}<span class="b2 bold" style="font-size: 2vmin">시간 </span> </template>
                                                <template v-if="summaryData?.elapsedMinute !== 0"> {{ summaryData?.elapsedMinute }}<span class="b2 bold" style="font-size: 2vmin">분 </span> </template>
                                                <template v-if="summaryData?.elapsedSecond !== 0"> {{ summaryData?.elapsedSecond }}<span class="b2 bold" style="font-size: 2vmin">초</span> </template>
                                            </span>
                                            <span class="standard">60</span>분
                                        </span>
                                    </li>
                                </ul>
                                <p class="detail__txt bold" v-html="comments?.commentDiagnosticResult" style="padding: 0px"></p>
                                <div class="reference">
                                    <p class="reference__title"><span class="required">*</span>독해력</p>
                                    <p class="reference__txt">지문을 적정 시간에 정확하게 읽고, 이해하여 문제를 해결할 수 있는 능력​</p>
                                </div>
                            </div>
                        </div>
                        <div class="print__content" style="margin-top: 50px">
                            <div class="content__header">
                                <h4 class="content__title">나의 KReaD<span class="required">*</span></h4>
                                <p class="kread-data">
                                    <img src="@/assets/images/symbols/logo_KRead_white.svg" class="kread-logo" alt="KRead logo" width="10%" />
                                    <span class="kread-number" style="margin-left: 5px">{{ summaryData?.kreadScore }}</span>
                                </p>
                            </div>
                            <div class="content__body">
                                <p class="detail__txt">
                                    {{ comments?.commentMyKread }}
                                </p>
                                <div style="padding: 2vw; background-color: #fafafa; margin-top: 10px">
                                    <div class="row" style="">
                                        <div class="" style="font-size: 1.6vw; padding: 20px 20px 26px; font-weight: 700; display: inline-flex; align-items: flex-end">나의 크리드</div>
                                        <div class="col">
                                            <KreadChart v-if="summaryData" :value="summaryData?.kreadScore" :height="2" />
                                        </div>
                                    </div>
                                </div>
                                <div class="reference" style="margin-top: 1vw">
                                    <p class="reference__title"><span class="required">*</span>KReaD</p>
                                    <p class="reference__txt">
                                        KReaD는 학습자가 능숙하게 읽을 수 있는 지문의 수준을 객관적 수치로 나타낸 것입니다. 숫자가 클수록 학습자의 독해 수준이 높음을 의미하며, 연령별 평균 KReaD는 연령*100으로 계산할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="print__content" style="margin-top: 50px">
                            <div class="content__header">
                                <h4 class="content__title">학습 출발점</h4>
                                <p class="learning-data">{{ summaryData?.level }}레벨 {{ summaryData?.lesson }}레슨</p>
                            </div>
                            <div class="content__body">
                                <p class="detail__txt">
                                    {{ comments?.commentStartPoint }}
                                </p>
                                <div style="padding: 2vw; background-color: #fafafa; margin-top: 10px">
                                    <div class="row">
                                        <!-- <div class="content__level-title" style="font-size: 1.6vw; padding: 0px 20px; font-weight: 700; display: inline-flex; align-items: center">나의 레벨</div> -->
                                        <div class="content__level-title">나의 레벨</div>
                                        <div class="col">
                                            <LevelLineChart v-if="summaryData?.level" :value="summaryData?.level" :height="lineChartStyleConfig.height" :color="lineChartStyleConfig.color" />
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top: 1.25vmin">
                                        <!-- <div class="content__lesson-title" style="font-size: 1.6vw; padding: 0px 20px; font-weight: 700; display: inline-flex; align-items: center">나의 레슨</div> -->
                                        <div class="content__lesson-title">나의 레슨</div>
                                        <div class="col">
                                            <LessonChart v-if="summaryData?.lesson" :lesson="summaryData?.lesson" :height="lineChartStyleConfig.height" printpage="true" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="print__section">
                    <div class="print__content">
                        <h4 class="content__title">학습 상세분석</h4>
                        <div class="content__body">
                            <div class="content__section">
                                <h5 class="detail__title">갈래/주제별 독해력 분석</h5>
                                <p class="detail__txt">
                                    {{ comments?.commentTopic }}
                                </p>
                                <div class="detail__graph">
                                    <div class="graph__content">
                                        <p class="graph__title">문학</p>
                                        <div class="graph" style="width: 100%; background-color: #fafafa; padding: 10px 20px 20px; height: 460px; display: flex; justify-content: center; align-items: center">
                                            <div class="radarchart" style="width: 100%; height: 100%">
                                                <RadarChart v-if="lTopicChartData" :chart-data="lTopicChartData" :chartFontSizeData="chartFontSizeData" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="graph__content">
                                        <p class="graph__title">비문학</p>
                                        <div class="graph" style="width: 100%; background-color: #fafafa; padding: 10px 20px 20px; height: 460px; display: flex; justify-content: center; align-items: center">
                                            <div class="radarchart" style="width: 100%; height: 100%">
                                                <RadarChart v-if="nTopicChartData" :chart-data="nTopicChartData" :chartFontSizeData="chartFontSizeData" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="content__section">
                                <h5 class="detail__title">사고 유형별<span class="required">*</span> 강약점</h5>
                                <p class="detail__txt">{{ comments?.commentAnalysis }}</p>
                                <div style="height: 530px; width: 100%; background-color: #fafafa; margin-top: 0.97vw; padding: 10px 30px">
                                    <columChart v-if="analysisChartData.length > 0" :chartData="analysisChartData" height="95%" width="1550px" :chartFontSizeData="commonPrintColumnChartFontData" />
                                </div>
                                <div class="reference">
                                    <p class="reference__title"><span class="required">*</span>사고 유형</p>
                                    <p class="reference__txt">
                                        사실적독해 : 글에 표면적으로 드러난 정보를 파악하여 글의 내용을 체계적으로 이해하는 능력​<br />
                                        추론적독해 : 생략된 정보를 추론하고, 글에 드러난 단서를 근거로 글쓴이의 의도나 목적을 추측하는 능력​​<br />
                                        비판적독해 : 글에 사용된 자료가 정확한지, 글쓴이의 주장이나 의견이 타당한지 점검하며 글을 읽는 능력​​<br />
                                        감상적독해 : 글에서 공감하거나 감동적인 부분을 읽고 글에 담긴 가치를 종합적으로 이해하는 능력​​<br />
                                        개념 : 개념을 적용하여 글을 이해하고 판단하는 능력​​<br />
                                        어휘 : 글에 나온 어휘의 의미를 알고 문맥에 맞게 사용하며 적용할 수 있는 능력
                                    </p>
                                </div>
                            </div>
                            <div class="content__section">
                                <h5 class="detail__title">질문 유형별 강약점</h5>
                                <p class="detail__txt">{{ comments?.commentProblemType }}</p>
                                <div style="height: 530px; width: 100%; background-color: #fafafa; margin-top: 0.97vw; padding: 10px 30px">
                                    <columChart v-if="problemTypeChartData.length > 0" :chartData="problemTypeChartData" width="1550px" height="95%" :chartFontSizeData="commonPrintColumnChartFontData" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="print__section">
                    <div class="print__content">
                        <h4 class="content__title">문항별 풀이 결과</h4>
                        <div class="content__body">
                            <div class="content__section">
                                <h5 class="detail__title">문학</h5>
                                <table class="detail__table p_margin">
                                    <!-- 
                                              table 디자인 규칙을 만들 수가 없어서 td에 디자인별 class 개별로 들어가 있습니다.
                                          -->
                                    <thead>
                                        <tr>
                                            <th width="7%">번호</th>
                                            <th width="18%">갈래/주제 및 지문</th>
                                            <th width="6%">KReaD</th>
                                            <th width="9%">목표시간</th>
                                            <th width="15%">풀이시간</th>
                                            <th width="12%">사고 유형</th>
                                            <th width="25%">학습 개념 상세</th>
                                            <th width="8%">정답여부</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="problemList">
                                        <tr v-for="(vData, index) in Object.values(problemList?.problemResultListL)">
                                            <td class="text-center" v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">{{ index + 1 }} - {{ index + 3 }}</td>
                                            <td class="txt--left" v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">
                                                <!-- <div style="width: calc( 100vw - 750px);text-overflow: ellipsis !important;white-space: nowrap !important;overflow: hidden !important;"> -->
                                                <span class="subject">{{ vData?.topic }}</span>
                                                {{ vData?.passageName }}
                                                <!-- </div> -->
                                            </td>
                                            <td v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">{{ vData?.kreadScore }}</td>
                                            <td v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">
                                                {{ getTimeStringSecondsKor(vData?.solveTime) }}
                                            </td>
                                            <td v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">
                                                <span :style="vData?.elapsedTime > vData?.solveTime ? 'run-time over-time' : ''">
                                                    {{ getTimeStringSecondsKor(vData?.elapsedTime) }}
                                                </span>
                                            </td>
                                            <td>{{ vData?.analysisName }}</td>
                                            <td>
                                                <!-- <div style="width: 200px;text-overflow: ellipsis !important;white-space: nowrap !important;overflow: hidden !important;"> -->
                                                {{ vData?.learningConceptName }}
                                                <!-- </div> -->
                                            </td>
                                            <td>
                                                <span :class="'correct' + (vData.correctYn === 1 ? '1' : '3')">정답 </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="content__section">
                                <h5 class="detail__title">비문학</h5>
                                <table class="detail__table">
                                    <!-- 
                                              table 디자인 규칙을 만들 수가 없어서 td에 디자인별 class 개별로 들어가 있습니다.
                                          -->
                                    <thead>
                                        <tr>
                                            <th width="7%">번호</th>
                                            <th width="18%">갈래/주제 및 지문</th>
                                            <th width="6%">KReaD</th>
                                            <th width="10%">목표시간</th>
                                            <th width="16%">풀이시간</th>
                                            <th width="12%">사고 유형</th>
                                            <th width="25%">학습 개념 상세</th>
                                            <th width="6%">정답여부</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="problemList">
                                        <tr v-for="(vData, index) in Object.values(problemList?.problemResultListN)">
                                            <td class="text-center" v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">{{ index + 1 + 15 }} - {{ index + 3 + 15 }}</td>
                                            <td class="txt--left" v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">
                                                <!-- <div style="width: calc( 100vw - 750px);text-overflow: ellipsis !important;white-space: nowrap !important;overflow: hidden !important;"> -->
                                                <span class="subject">{{ vData?.topic }}</span>
                                                {{ vData?.passageName }}
                                                <!-- </div> -->
                                            </td>
                                            <td v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">{{ vData?.kreadScore }}</td>
                                            <td v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">
                                                {{ getTimeStringSecondsKor(vData?.solveTime) }}
                                            </td>
                                            <td v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">
                                                <span :style="vData?.elapsedTime > vData?.solveTime ? 'run-time over-time' : ''">
                                                    {{ getTimeStringSecondsKor(vData?.elapsedTime) }}
                                                </span>
                                            </td>
                                            <td>{{ vData?.analysisName }}</td>
                                            <td>
                                                <!-- <div style="width: 200px;text-overflow: ellipsis !important;white-space: nowrap !important;overflow: hidden !important;"> -->
                                                {{ vData?.learningConceptName }}
                                                <!-- </div> -->
                                            </td>
                                            <td>
                                                <span :class="'correct' + (vData.correctYn === 1 ? '1' : '3')">정답 </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    </body>
</template>

<script setup>
import StudyHeader from '@/components/layouts/header/studyHeader.vue';
import GaugeChart from '@/components/chart/gaugeChart.vue';
import { onMounted, ref, computed, watch, defineProps, reactive } from 'vue';
import { getUserJson, postUserJson } from '@/api/modules/login';
import { GlobalStore } from '@/store';
import _ from 'lodash';
import { getReportDiagnostic, getReportReview } from '@/api/modules/study';
import { StudyStore } from '@/store/modules/study';
import { getTimeStringSecondsKor, getKreadGrade } from '@/helpers/utils';
import { useRouter } from 'vue-router';
import CqBtn from '@/components/quasar/cqBtn.vue';
import { analysis, difficult, problemType } from '@/helpers/qbankParser/qbankMeta';
import moment from 'moment';
import { useQuasar } from 'quasar';
import Help from '@/components/quasar/help.vue';
import Review from '../component/review.vue';
import { testData } from './test';
import columChart from '@/components/chart/columChart.vue';
import { DialogStore } from '@/store/modules/dialog';
import RadarChart from '@/components/chart/radarChart.vue';
import LessonChart from '@/components/chart/lessonChart.vue';
import LevelLineChart from '@/components/chart/levelLineChart.vue';
import KreadChart from '@/components/chart/kreadChart.vue';
import { commonPrintColumnChartFontData } from '@/config/styleConfig';

import Comm from '@/components/common.js';
const isLog = true;
// import { GlobalStore } from '@/store';
const gStore = GlobalStore();

const $q = useQuasar();
const coreProcess = ref(0.5);
const model = ref('1');
const user = ref(null);
const reviewModal = ref(false);
const answerHistorySeq = ref(null);
let answerNum = null;
const tab = ref('passage1');
const globalStore = GlobalStore();
const studyStore = StudyStore();
const summaryData = ref(null);
const comments = ref(null);
const passageList = ref(null);
const problemList = ref(null);
const analysisResult = ref({});
const analysisChartData = ref([]);
// const chartFontSizeData = reactive({
//     xAxis: '3.2vmin',
//     yAxis: '3.8vmin',
//     percentNum: '4vmin',
//     radarChartText: '3.1vmin',
//     fontWeight: 550,
// });
//하단부 2가지 라인 차트 config
const lineChartStyleConfig = {
    height: 2.33,
    color: '#18b73f',
};

const problemTypeChartData = ref([]);
const lTopicChartData = ref(null);
const nTopicChartData = ref(null);
const router = useRouter();
const store = DialogStore();

const comUserName = computed(() => {
    return Comm.getStrName();
});
const comSchoolAndGrade = computed(() => {
    return Comm.getDiagnosticSchoolAndGrade();
});

// 회원여부 체크
// const isMember = gStore.is_member_eval;
// 비회원 학년 정보
// const nonMemberSchoolGrade = computed(() => {
//     if (gStore.evalData.first_kread === 'M2') return '중학교 2학년';
//     if (gStore.evalData.first_kread === 'M3') return '중학교 3학년';
//     return '중학교 1학년';
// });
// const getStringUserGrade = computed(() => {
//     return Comm.getHakNyoun(globalStore.userInfo.grade);
// });

const props = defineProps({
    reportData: {
        default: null,
        // default: {
        //   areaCode: "02",
        //   learningHistorySeq: 2338,
        //   learningTypeCode: 1,
        //   lesson: 1,
        // }
    },
    isPrintMode: {
        default: false,
    },
    isAnalysisMenu: {
        dafault: false,
    },
});

const onClickReview = (seq, num) => {
    // console.log(seq);
    // console.log(num);
    answerHistorySeq.value = seq;
    answerNum = num;
    reviewModal.value = true;
    // getReportReview({ answerHistorySeq: seq }, (rs) => {
    //   console.log(rs);
    // })
};

const setData = (rs) => {
    // console.log('--setData-rs schoolGrade-', rs.diagnosticInfo.schoolGrade);
    gStore.setEvalRealGrade(rs.diagnosticInfo.schoolGrade); // 비회원 실제학년정보 수정.

    // console.log(rs);
    // const rs = testData;
    summaryData.value = rs.diagnosticInfo;
    // passageList.value = { passageResultListL: rs.passageResultListL, passageResultListN: rs.passageResultListN, };
    let tmpLiteratureResult = [];
    rs.literatureResult.forEach((item) => {
        item.problemResultList.forEach((i) => {
            tmpLiteratureResult.push({ ...i, elapsedTime: item.elapsedTime, kreadScore: item.kreadScore, passageName: item.passageName, passageSeq: item.passageSeq, solveTime: item.solveTime, topic: item.topic });
        });
    });
    let tmpNonLiteratureResult = [];
    rs.nonLiteratureResult.forEach((item) => {
        item.problemResultList.forEach((i) => {
            tmpNonLiteratureResult.push({ ...i, elapsedTime: item.elapsedTime, kreadScore: item.kreadScore, passageName: item.passageName, passageSeq: item.passageSeq, solveTime: item.solveTime, topic: item.topic });
        });
    });
    // 첫 3지문 크리드점수 지우기
    const REtmpLiteratureResult = tmpLiteratureResult.map((e, i) => {
        // console.log('--REtmpLiteratureResult-kreadScore-',e.kreadScore)
        return i < 9 ? { ...e, kreadScore: '-' } : e;
    });
    problemList.value = { problemResultListL: REtmpLiteratureResult, problemResultListN: tmpNonLiteratureResult };
    //  console.log('----REtmpLiteratureResult---- ', REtmpLiteratureResult);
    // problemList.value = { problemResultListL: tmpLiteratureResult, problemResultListN: tmpNonLiteratureResult, };
    // console.log(problemList);
    let tmpChartData = [];
    comments.value = {
        commentAnalysis: rs.commentAnalysis,
        commentDiagnosticResult: rs.commentDiagnosticResult,
        commentMyKread: rs.commentMyKread,
        commentProblemType: rs.commentProblemType,
        commentStartPoint: rs.commentStartPoint,
        commentTopic: rs.commentTopic,
    };
    Object.entries(analysis).forEach(([k, v]) => {
        if (rs.analysisResult['analysis' + k] > -1) {
            if (v.ord < 4) {
                tmpChartData.push({
                    category: v.label + ' 독해',
                    value1: rs.analysisResult['analysis' + k] < 0 ? 0 : rs.analysisResult['analysis' + k],
                    ord: v.ord,
                });
            } else {
                tmpChartData.push({
                    category: v.label,
                    value1: rs.analysisResult['analysis' + k] < 0 ? 0 : rs.analysisResult['analysis' + k],
                    ord: v.ord,
                });
            }
        }
    });
    const topicType = {
        passage01: '현대시',
        passage02: '고전시가',
        passage03: '고전산문',
        passage04: '현대소설',
        passage05: '극·수필',
        passage06: '인문',
        passage07: '예술',
        passage08: '정치·사회',
        passage09: '경제·문화',
        passage10: '과학',
        passage11: '기술',
        passage12: '융합',
    };
    let tmpLTopic = [];
    let tmpNTopic = [];
    Object.keys(rs.topicResult).forEach((k, i) => {
        if (i < 5) {
            tmpLTopic.push({ name: topicType[k], value: rs.topicResult[k] });
        } else {
            tmpNTopic.push({ name: topicType[k], value: rs.topicResult[k] });
        }
    });
    lTopicChartData.value = tmpLTopic;
    nTopicChartData.value = tmpNTopic;
    // console.log(tmpLTopic)
    // console.log(tmpNTopic)
    // Object.entries(testData.analysisResult).forEach(([k, v]) => {

    //   const tmpKey = k.replace('analysis', '');
    //   if (analysis[tmpKey].ord < 4) {
    //     tmpChartData.push({
    //       category: analysis[tmpKey].label + " 독해",
    //       value1: v,
    //     })
    //   } else {
    //     tmpChartData.push({
    //       category: analysis[tmpKey].label,
    //       value1: v,
    //     })
    //   }
    // });
    analysisChartData.value = _.sortBy(tmpChartData, 'ord');
    let tmpProblemTypeChartData = [];
    Object.entries(problemType).forEach(([k, v]) => {
        tmpProblemTypeChartData.push({
            category: v,
            value1: rs.problemTypeResult[k] < 0 ? 0 : rs.problemTypeResult[k],
        });
    });
    problemTypeChartData.value = tmpProblemTypeChartData;
    // console.log(_.isEmpty(globalStore.userInfo));
    // if (_.isEmpty(globalStore.userInfo)) {
    // globalStore.getUserInfo();
    // console.log(globalStore.getUserInfo());
    // }
    user.value = globalStore.userInfo;
};

onMounted(() => {
    // summaryData.value = {
    //   totalAccuracyRate: testData.totalAccuracyRate,
    //   coreResult: testData.totalLearningResult.coreResult,
    //   earnestResult: testData.totalLearningResult.earnestResult,
    //   vocabularyResult: testData.totalLearningResult.vocabularyResult,
    // }
    // passageList.value = testData.passageList
    // getReportSat({ learningHistorySeq: 760 }, (rs) => {
    if (props?.reportData) {
        setData(props?.reportData);
    }

    // console.log(props.isAnalysisMenu)
});

const movePg = () => {
    gStore.is_member_eval ? router.push('/learninghome') : router.push('/eval-login');
};

const checkConfirm = (val) => {
    val && router.push('/learninghome');
};

const onClickHome = () => {
    store.openConfirmDialog({
        message: '홈으로 이동하시겠습니까?',
        cancel: '닫기',
        ok: '확인',
        callback: checkConfirm,
    });
};
</script>

<style scoped lang="scss">
::v-deep .reference__txt {
    margin: 0 0 0px !important;
}

@import '../print.scss';

.content__level-title,
.content__lesson-title {
    font-size: 1.3vw;
    padding: 0px 20px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
}
</style>
